import React, { FC } from 'react'
import { ClbCard, ClbIcon, ClbLink } from '@celebration/react'
import { Icons as ClbIconsOptions } from '@celebration/react/ClbIcon/props.types'
import { IMfeMenu, IMfeMenuItem, MfeRouteGroup, VisibleMfeRouteGroup } from '../../mfe/types'
import { MenuContainer, MenuList, MenuListItem, MenuTitle } from './styles/MenusLinks.styles'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/types'

const MENUS_ICONS_NAMES: Record<VisibleMfeRouteGroup, ClbIconsOptions> = {
  [MfeRouteGroup.Freights]: 'report',
  [MfeRouteGroup.Financial]: 'file',
  [MfeRouteGroup.Register]: 'anotacoes',
  [MfeRouteGroup.Cockpit]: 'history',
  [MfeRouteGroup.Dochub]: 'download'
}

const MenusLinks: FC = (): React.ReactElement => {
  const mfeMenus = useSelector((state: RootState) => state.mfe.menus)

  const renderMenuItem = ({ label, path }: IMfeMenuItem, index: number): React.ReactElement => (
   <MenuListItem key={index}>
      <ClbLink rel='nofollow' target='_self' href={path}>
        {label}
      </ClbLink>
    </MenuListItem>
  )

  const renderMenu = ({ name, routeGroup, items }: IMfeMenu, index: number): React.ReactElement => (
    <ClbCard key={index} data-testid='menu'>
      <ClbIcon icon={MENUS_ICONS_NAMES[routeGroup]} size='lg' />
      <MenuTitle size='2xs' type='h2'>
        {name}
      </MenuTitle>
      <MenuList>{items.map((item, itemIndex) => renderMenuItem(item, itemIndex))}</MenuList>
    </ClbCard>
  )

  return <MenuContainer>{mfeMenus.map((menu, index) => renderMenu(menu, index))}</MenuContainer>
}

export default MenusLinks
